import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import "./ModalComponent.css";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import CssBaseline from "@material-ui/core/CssBaseline";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import TextField from "@material-ui/core/TextField";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import useStyles from "./styles";

export default function ModalComponent({
  open,
  setOpen,
  updateData,
  setData,
  action,
  setAction,
  TakeAction,
}) {
  const handleClose = () => setOpen(false);
  const handleChange = (event) => {
    setAction(event.target.value);
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <CssBaseline />
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Want to disable user?"}
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Add the UID"
            placeholder="Add the UID"
            variant="outlined"
            onChange={(event) => setData(event.target.value)}
          />
          <FormLabel
            component="legend"
            style={{ textAlign: "center", marginTop: "1em" }}
          >
            Actions
          </FormLabel>
        </DialogContent>
        <DialogActions justifyContent="center">
          <RadioGroup
            aria-label="action"
            name="action"
            value={action}
            onChange={handleChange}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <FormControlLabel
              value="enable"
              control={<Radio />}
              label="Enable"
              style={{
                display: "flex",
                alignSelf: "auto",
              }}
            />
            <FormControlLabel
              value="disable"
              control={<Radio />}
              label="Disable"
              style={{
                display: "flex",
                alignSelf: "auto",
              }}
            />
          </RadioGroup>
        </DialogActions>
        <Button
          onClick={TakeAction}
          color="primary"
          variant="contained"
          autoFocus
          style={{margin: '1em'}}
        >
          Take Action
        </Button>
        <Button
          onClick={handleClose}
          color="secondary"
          variant="contained"
          autoFocus
          style={{margin: '0 1em 1em 1em'}}
        >
          Cancel Action
        </Button>
      </Dialog>
    </>
  );
}
